import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UrlBuilder } from '../utils/url-builder';
import { FamilyProfile } from '../models/family-profile.model';

enum ApiEndpoint {
  GetPatchFamilyProfile = '/family-metadata',
}

@Injectable({ providedIn: 'root' })
export class FamilyProfileProvider {
  constructor(private http: HttpClient) {}

  getFamilyMetadata(): Observable<FamilyProfile> {
    const url = new UrlBuilder(ApiEndpoint.GetPatchFamilyProfile).getUrl();

    return this.http.get<FamilyProfile>(environment.usersBaseUrl + url);
  }

  patchFamilyMetadata(familyProfile: FamilyProfile): Observable<FamilyProfile> {
    return this.http.patch<FamilyProfile>(environment.usersBaseUrl + ApiEndpoint.GetPatchFamilyProfile, familyProfile);
  }
}
